module.exports = __webpack_public_path__ + "img/744.2a199f3b.jpg";